import React from 'react';
import {Helmet} from 'react-helmet';

export default function CookieStatement() {
  if (window && window.navigator && window.navigator.userAgent === 'ReactSnap') {
    return (
      <div></div>
    );
  }
  return (
    <Helmet>
      <script
        src="https://cdn-apac.onetrust.com/scripttemplates/otSDKStub.js"
        data-document-language="true"
        type="text/javascript"
        charSet="UTF-8"
        data-domain-script="3d7f7698-1106-4b40-b496-b67d5b55e822"
      />
      <script type="text/javascript">{`function OptanonWrapper() {}`}</script>
    </Helmet>
  );
}
